import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b9ac2cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content"
}
const _hoisted_2 = { class: "errors-nav" }
const _hoisted_3 = { class: "page" }
const _hoisted_4 = { class: "buttons" }
const _hoisted_5 = {
  key: 1,
  class: "mt-6"
}

import { computed, ref } from 'vue'

import Modal from '@/popup/components/shared/Modal/Modal'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import Button from '@/popup/components/shared/Button.vue'
import { Textarea } from '@/popup/components/shared/Form/Form'
import { InternalMethods } from '@/shared/apis/messages'
import { useGlobals } from '@/popup/compositions/useGlobals'
import ClipboardButton from '../shared/ClipboardCopy/ClipboardButton.vue'
import Skeleton from '@/popup/components/shared/Skeleton.vue'
import { useAppStore } from '@/popup/store/AppStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'SomethingWentWrongErrorModal',
  setup(__props) {

const appStore = useAppStore()

const activelyViewedErrorIndex = ref(0)

const onClose = async () => {
  await useGlobals().sendMessage({
    method: InternalMethods.READ_APPLICATION_ERRORS,
    payload: undefined,
  })
}

const appErrors = computed(() => {
  const errors = appStore.somethingWentWrongErrors
  return errors.reverse()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal).Wrapper, { "extra-class": "wider" }, {
    default: _withCtx(() => [
      _createVNode(_unref(Modal).Background, {
        "extra-class": "darker blurry",
        onClick: () => {}
      }),
      _createVNode(_unref(Modal).Content, { "extra-class": "wider higher" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Modal).Heading, { "extra-class": "larger" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('modal.app_errors.something_went_wrong')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          (appErrors.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(Textarea), {
                  readonly: "",
                  rows: 10,
                  value: appErrors.value[activelyViewedErrorIndex.value]?.message
                }, null, 8 /* PROPS */, ["value"]),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`page-nav-icon ${
              activelyViewedErrorIndex.value === 0 ? 'disabled' : 'is-clickable'
            }`)
                  }, [
                    _createVNode(SvgIcon, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (activelyViewedErrorIndex.value -= 1)),
                      name: "arrow-left-lg",
                      height: "16",
                      width: "16",
                      "data-testid": "back-button"
                    })
                  ], 2 /* CLASS */),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(activelyViewedErrorIndex.value + 1) + " of " + _toDisplayString(appErrors.value.length), 1 /* TEXT */),
                  _createElementVNode("div", {
                    class: _normalizeClass(`page-nav-icon ${
              activelyViewedErrorIndex.value === appErrors.value.length - 1
                ? 'disabled'
                : 'is-clickable'
            }`)
                  }, [
                    _createVNode(SvgIcon, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (activelyViewedErrorIndex.value += 1)),
                      name: "arrow-right-lg",
                      height: "16",
                      width: "16",
                      "stroke-width": "2",
                      "data-testid": "back-button"
                    })
                  ], 2 /* CLASS */)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(Button, {
                    variant: "text",
                    class: "mt-3",
                    onClick: onClose
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('modal.developer.close')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(ClipboardButton, {
                    value: appErrors.value[activelyViewedErrorIndex.value]?.message,
                    "copy-text": _ctx.$t('modal.app_errors.copy_error'),
                    "copied-text": _ctx.$t('modal.app_errors.copied'),
                    class: "mt-3"
                  }, null, 8 /* PROPS */, ["value", "copy-text", "copied-text"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(Skeleton, {
                  name: "loading-full-length",
                  width: "300",
                  height: "40"
                }),
                _createVNode(Skeleton, {
                  name: "loading-full-length",
                  width: "300",
                  height: "40"
                }),
                _createVNode(Skeleton, {
                  name: "loading-full-length",
                  width: "300",
                  height: "40"
                })
              ]))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})